<template>
  <modal :title="'User Hotels'" :size="'xl'" @close="$emit('close')">
    <template #content>
      <div
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="addShow = true"
            :key="index"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add Hotel</span>
          </button>
        </div>
      </div>
      <dataTable
        :name="'UserHotels'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updateShow = $event"
        @writeScript="writeScript"
        @test="test"
        @sync="sync"
        @remove="remove"
        :rowClassRules="{
            danger: (params) => {
              return params?.data?.ControlRequired || params?.data?.SyncError;
            },
        }"
        :addContextMenuItem="getContextMenuItems"
        @cellClicked="updateShow = $event.data"
      ></dataTable>
      <modal
        size="lg"
        title="Error"
        v-if="errorOpen != null"
        @close="errorOpen = null"
      >
        <template #content>
          <pre class="m-0">{{ errorOpen.SyncErrorMessage }}</pre>
        </template>
      </modal>
      <upsert
        v-if="addShow || updateShow != null"
        :userId="userId"
        :customerId="customerId"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        :setModel="updateShow"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </template>
  </modal>
</template>

<script>
import moment from "moment";
import upsert from "./upsert";
export default {
  name: "users",
  components: { upsert },
  props: {
    userId: Number,
    customerId: Number,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 3,
          minWidth: 120,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "P1",
          filter: "agTextColumnFilter",
          field: "P1",
          flex: 1,
          minWidth: 90,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "P2",
          filter: "agTextColumnFilter",
          field: "P2",
          flex: 1,
          minWidth: 90,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "P3",
          filter: "agTextColumnFilter",
          field: "P3",
          flex: 1,
          minWidth: 90,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "P4",
          filter: "agTextColumnFilter",
          field: "P4",
          flex: 1,
          minWidth: 90,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "P5",
          filter: "agTextColumnFilter",
          field: "P5",
          flex: 1,
          minWidth: 90,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "Last Check Date",
          filter: "agTextColumnFilter",
          field: "LastCheckDate",
          flex: 1,
          minWidth: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            return params.value==null?"":moment(new Date(params.value)).format("DD-MM-YYYY HH:mm");
          },
        },
        {
          headerName: "Error Message",
          filter: "agTextColumnFilter",
          field: "ErrorMessage",
          flex: 1,
          minWidth: 150,
          sortable: true,
          cellClick: true,
        },
      ],
      errorOpen: null,
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`UserHotels/` + this.userId).then((response) => {
      this.data = response.data;
      this.detailShow = this.data[0];
    });
  },
  methods: {
    test(item) {
      this.$appAxiosAdmin
        .post(`Hotels/TestConnection`, {
          SoftwareId: item.SoftwareId,
          P1: item.P1,
          P2: item.P2,
          P3: item.P3,
          P4: item.P4,
          P5: item.P5,
          // this.model
        })
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully connected.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    sync(item) {
      this.processSync = true;
      this.$appAxiosAdmin
        .post(`Functions/SoftwareSync`, {
          SoftwareId: item.SoftwareId,
          P1: item.P1,
          P2: item.P2,
          P3: item.P3,
          P4: item.P4,
          P5: item.P5,
          // this.model
        })
        .then(() => {
          this.processSync = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully software sync.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processSync = false;
          this.$isError(err);
        });
    },
    writeScript(item) {
      this.$appAxiosAdmin
        .get(`Hotels/WriteScript/` + item.Id)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully whire script.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the user hotel named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`UserHotels/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The user hotel has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Update",
          icon: "<i class='fas fa-pencil-alt'></i>",
          action: () => {
            this.updateShow = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
};
</script>
